import { ReactComponent as Wave } from '../assets/wave.svg';
import WeatherTime from '../WeatherTime';
import style from './style.module.scss';
import clsx from 'clsx';

const TopMenu = ({ menu, isHome }) => {
    return (
        <ul className={clsx(style.topMenu, isHome && style.home)}>
            {menu?.map((menuItem, _) => {
                return (
                    <li key={menuItem.ID} className={style.menuItem}>
                        <a href={menuItem.url} className={style.menuItemUrl}>
                            {menuItem.title}
                            <Wave className={style.wave} />
                        </a>
                    </li>
                );
            })}
            <WeatherTime />
        </ul>
    );
};

export default TopMenu;
